import { InteractionTypes } from './interactions-entities'
/**
 * Enum that contains the list of streaming services used.
 */
export enum StreamServiceType {
    MUX = 'MUX',
    SVS = 'SVS',
    NONE = 'NONE'
}

export enum StreamBroadcastStatus {
    OFF = 'OFF',
    BROADCAST = 'BROADCASTING',
    WAITINGROOM = 'WAITINGROOM'
}

export enum VideoType {
    DAILY = 'DAILY',
    EVERYDAY = 'EVERYDAY'
}

class FCMData {
    private title: string
    private body: string
    private status: StreamBroadcastStatus
    private hlsLink: string = ''

    constructor(title: string, body: string, status: StreamBroadcastStatus) {
        this.title = title
        this.body = body
        this.status = status
    }

    public setHLSURL(url: string) {
        this.hlsLink = url
    }

    public getPayload(): any {
        return {
            data: {
                hlsUrl: this.hlsLink,
                status: this.status
            },
            notification: {
                body: this.body,
                sound: 'default',
                title: this.title
            }
        }
    }
}

export class StreamFCMData extends FCMData {
    private dynamicTitle: string

    constructor(title: string, dynamicTitle: string, body: string, status: StreamBroadcastStatus) {
        super(title, body, status)
        this.dynamicTitle = dynamicTitle
    }

    public getDynamicPaylod(teacherName: string): any {
        const result = this.getPayload()
        const newTitle = this.dynamicTitle.replace('%TEACHER%', teacherName)
        result.notification.title = newTitle
        return result
    }
}

/**
 * the FCM payload when the live stream is active.
 */
export const streamIsReadyFCM = new StreamFCMData('A LIVE practice is starting soon!', 'It’s almost time ⏰ to practice with %TEACHER%!', 'Get comfortable and join us in the waiting room', StreamBroadcastStatus.WAITINGROOM)

/**
 * the FCM payload when the live stream is broadcasting.
 */
export const streamIsBroadcastingFCM = new StreamFCMData('We’re starting our LIVE practice!', 'It’s time 🙌 %TEACHER% is starting now!', 'Take a deep breath and let’s practice together', StreamBroadcastStatus.BROADCAST)



/**
 * StreamConfig object
 */
export class StreamConfig {
    public activeService = StreamServiceType.NONE
    public broadcastStatus = StreamBroadcastStatus.OFF
    public activeURL = ''
    public interaction = InteractionTypes.NONE
    public streamId = ''
    public simulation = false
    public courseId = ''
    public teacherId = ''
    public selectedClassPublicationDate = '';
    public replayDescription = '';
}

/**
 * CourseConfig object
 */
export class CourseConfig {
    public id: string = '';
    public titleLabel: string = '';
    public descriptionLabel: string = '';
    public backgroundImgURL: string = '';
    public teacherDayMapping: TeacherDayMapping[] = [];
    public timeOfTheDay: string = '';
    public duration: number = 15;
    public description: string = '';
}

export class ClassConfig extends CourseConfig {
    public teacherId: string = ''
}

export class TeacherDayMapping {
    public dayIndex: number = 0;
    public teacherId: string = '';
    public theme: string = '';
    public title: string = '';
    public duration: number | null = null;
    public coverImageUrl: string = '';
    public customDescription: string = '';
}

/**
 * User
 */
export class UserData {
    public uuid: string = ''
    public firstname: string = ''
    public lastname: string = ''
    public email: string = ''
    public createdDate: Date
    public modifiedDate: Date
    public roles: string[] = []
    public streak: number = 0
    public lastClassDate: Date
    public followClasses: string[] = []
    public invitationCode: string = ''
    public isSubscriptionValid: boolean = false
    public lastestReceipt: string = ''
}

export class Purchase {
    public productId: string
    public transactionId: string
    public originalTransactionId: string
    public isTrialPeriod: boolean
    public purchaseDate: Date
    public expiresDate: Date
}

export class DailyVodConfig {
    public id: string = ''
    public teacherId: string = ''
    public vimeoURL: string = ''
    public playbackURL: string = ''
    public publishDate: Date
    public duration: number = 0
    public type: VideoType
    public categories: string[] = []
    public description: string = ''
    public descriptionLong: string = ''
    public priority: number = 0;
    public analyticsType: string = '';
    public theme: string = '';
    public availableInHomePage: boolean = false;
    public coverImageUrl: string = '';
}

export class VodCategory {
    public id: string = ''
    public name: string = ''
    public priority: number = -1
}

/**
 * TeacherConfig object
 */
export class TeacherConfig extends UserData {
    public description: string = ''
    public header: string = ''
    public photoURL: string = ''
    public bannerURL: string = ''
    public isConfirmed: boolean = false
    public dharma: string = ''
    public dharmaURL: string = ''
    public bioVimeoURL: string = ''
    public bioPlaybackURL: string = ''
}

export class PromocodeConfig {
    public id: string = ''
    public code: string = ''
    public domain: string = ''
    public expirationDate: Date
    public link: string = ''
    public isB2b: boolean = false
    public subscriptionId: string = ''
}



// WEBPACK FOOTER //
// ./src/configs/stream-entities.ts